import { useMutation } from "@tanstack/react-query";
import { httpClient, ROOT_URL } from "../App";
import { AxiosResponse } from "axios";

export const useAddBank = (config = {}) => {
  return useMutation({
    ...config,
    mutationFn: addBank,
  });
};

export function addBank(body: any): Promise<AxiosResponse<any>> {
  return httpClient.post(`${ROOT_URL}/api/v1/banks`, body);
}
